<script setup></script>

<template>
	<router-view />
</template>

<!-- This is the Application Shell. -->
